import { Droplet, Clock, Shield, Sparkles } from 'lucide-react';

export const services = [
  {
    icon: Sparkles,
    title: "Nettoyage Professionnel",
    description: "Costumes, chemises, manteaux nettoyés avec soin et expertise",
    items: ["Costumes", "Chemises", "Manteaux", "Vestes"]
  },
  {
    icon: Droplet,
    title: "Tapis, Moquettes & Literie",
    description: "Spécialiste du nettoyage tapis persan, oriental, kilim, berbère, moquettes et carpettes",
    items: ["Tapis persan & oriental", "Moquettes & carpettes", "Couettes & couvertures", "Rideaux & housses"]
  },
  {
    icon: Shield,
    title: "Vêtements Délicats",
    description: "Traitement spécialisé pour vos pièces précieuses",
    items: ["Robes de mariée", "Robes de soirée", "Écharpes", "Casquettes"]
  },
  {
    icon: Clock,
    title: "Service Rapide",
    description: "Repassage impeccable et service efficace",
    items: ["Repassage express", "Sacs de couchage", "Tous textiles"]
  }
];

export const galleryImages = [
  // 1. Costumes
  {
    url: "https://customer-assets.emergentagent.com/job_modern-portfolio-280/artifacts/kdkfg2ae_image.png",
    title: "Nettoyage à sec de costumes homme - Veste et pantalon",
    alt: "Costume homme noir nettoyé et repassé - Pressing professionnel AQUABLUENET Longpont Mennecy"
  },
  // 2. Cravate (gold)
  {
    url: "https://customer-assets.emergentagent.com/job_modern-portfolio-280/artifacts/t12qaw0i_image.png",
    title: "Cravate et accessoires de mariage / cérémonie",
    alt: "Nettoyage cravate, pochette et costume de cérémonie - Pressing spécialiste mariage AQUABLUENET"
  },
  // 2bis. Cravate AQUABLUENET tarif 5,50€
  {
    url: "https://customer-assets.emergentagent.com/job_modern-portfolio-280/artifacts/z88j4epj_2cf5d942-86dd-451d-9b82-9439b220c415.png",
    title: "Nettoyage cravates AQUABLUENET - Seulement 5,50€",
    alt: "Nettoyage cravate à 5€50 - Cravates nettoyées avec soin chez AQUABLUENET - Éclat, fraîcheur, tenue impeccable - Pressing Essonne"
  },
  // 3. Chemises classe (L'exigence du détail)
  {
    url: "https://customer-assets.emergentagent.com/job_modern-portfolio-280/artifacts/g2mc9u7q_88375cc6-d1c7-48b6-a37b-877444369654.png",
    title: "L'exigence du détail - Chemises haut de gamme, finitions parfaites",
    alt: "Chemises d'exception AQUABLUENET - Cols nets, manchettes parfaites, repassage haute précision, produits écologiques"
  },
  // 4. Promo 5 chemises = 4 (5ème offerte)
  {
    url: "https://customer-assets.emergentagent.com/job_modern-portfolio-280/artifacts/che271p4_2d67c062-93aa-4e42-8cc1-c1716323e064.png",
    title: "OFFRE EXCLUSIVE AQUABLUENET : 5 chemises, la 5ème offerte",
    alt: "Offre 5 chemises pour le prix de 4 - La 5ème chemise offerte - Pressing AQUABLUENET Longpont Mennecy"
  },
  // 5. Repassage
  {
    url: "https://customer-assets.emergentagent.com/job_modern-portfolio-280/artifacts/tod5h2fe_image.png",
    title: "Repassage professionnel - Fer vapeur industriel",
    alt: "Repassage professionnel de pantalons au fer vapeur - Service pressing AQUABLUENET en Essonne"
  },
  // 6. Robe de mariée AQUABLUENET premium
  {
    url: "https://customer-assets.emergentagent.com/job_modern-portfolio-280/artifacts/trges341_000ea983-44c3-451b-b0cc-b2645a02bf3c.png",
    title: "Nettoyage robe de mariée AQUABLUENET - Précieuse, unique, irremplaçable",
    alt: "Nettoyage robe de mariée en dentelle AQUABLUENET - Soin spécialisé, préservation dentelle perles broderies, conservation longue durée, pressing premium Essonne"
  },
  // 7. Robe de mariée (photo boutique)
  {
    url: "https://customer-assets.emergentagent.com/job_modern-portfolio-280/artifacts/21rbv3yi_DSCN1200.JPG",
    title: "Nettoyage robes de mariée - Certification Woolmark",
    alt: "Robe de mariée nettoyée - Pressing certifié Woolmark Approved à Longpont-sur-Orge"
  },
  // 8. Cuir
  {
    url: "https://customer-assets.emergentagent.com/job_modern-portfolio-280/artifacts/thiclkh5_image.png",
    title: "Cuir nettoyé en profondeur, protégé et nourri - Vestes & blousons motard",
    alt: "Vestes en cuir, manteaux, blousons de motard nettoyés en profondeur - Cuir protégé et nourri - Pressing écologique AQUABLUENET"
  },
  // 9. Intérieur boutique avec logo
  {
    url: "https://customer-assets.emergentagent.com/job_modern-portfolio-280/artifacts/w53b0azd_image.png",
    title: "Pressing AQUABLUENET - Intérieur moderne avec vêtements nettoyés",
    alt: "Intérieur pressing AQUABLUENET Nettoyage Écologique - Chemises, polos, doudounes, manteaux et tailleurs fraîchement nettoyés sur portants professionnels"
  },
  // 10. Tapis persan AQUABLUENET (nouvelle image, remplace doublon)
  {
    url: "https://customer-assets.emergentagent.com/job_modern-portfolio-280/artifacts/5veajola_e36d1554-afd6-4b13-bd0b-a9428a73bfcc.png",
    title: "Nettoyage tapis persan AQUABLUENET - Machine professionnelle rouge",
    alt: "Tapis persan avec franges nettoyé chez AQUABLUENET - Machine professionnelle Komman à rouleau rouge - Pressing spécialiste tapis Essonne"
  },
  // 11. Tapis persan machine brosses rotatives
  {
    url: "https://customer-assets.emergentagent.com/job_modern-portfolio-280/artifacts/2chq71rz_image.png",
    title: "Machine de nettoyage tapis haute pression - Tapis persan en lavage",
    alt: "Nettoyage tapis persan oriental sur machine professionnelle à brosses rotatives - Pressing AQUABLUENET"
  },
  // 12-15. Équipements pro
  {
    url: "https://customer-assets.emergentagent.com/job_modern-portfolio-280/artifacts/hgk8peg0_PHOTO-2026-04-17-19-35-48.jpg",
    title: "Machine Electrolux Lagoon - Nettoyage écologique 100% naturel",
    alt: "Machine professionnelle Electrolux Lagoon - Pressing écologique 0% Perchlo, 100% Naturel - AQUABLUENET"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_modern-portfolio-280/artifacts/6gz27als_PHOTO-2026-04-17-19-35-18_2.jpg",
    title: "Produit Lagoon Wetcleaning - Nettoyage écologique Electrolux",
    alt: "Produit Lagoon Wetcleaning by Electrolux - Pressing 0% Perchlo 100% Naturel conforme Directive Reach"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_modern-portfolio-280/artifacts/gyritsf1_PHOTO-2026-04-17-19-35-18.jpg",
    title: "Panneau de contrôle professionnel - Technologie CLARUS",
    alt: "Panneau de contrôle CLARUS des machines professionnelles de nettoyage - Pressing AQUABLUENET"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_modern-portfolio-280/artifacts/zakalx5k_PHOTO-2026-04-17-19-35-18_1.jpg",
    title: "Machine Electrolux T5350 - Équipement professionnel",
    alt: "Machine professionnelle Electrolux T5350 - Pressing écologique avec icônes environnementales"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_modern-portfolio-280/artifacts/11bfin61_photos%20RLB00470%20040.jpg",
    title: "Équipements professionnels Woolmark et Lagoon",
    alt: "Machines professionnelles Electrolux Woolmark T4350 et Lagoon - Pressing AQUABLUENET Longpont-sur-Orge"
  },
  {
    url: "https://images.unsplash.com/photo-1451933335233-c41672c8f378",
    title: "Nettoyage costumes homme",
    alt: "Costume noir nettoyé à sec - Pressing professionnel Essonne"
  },
  {
    url: "https://images.unsplash.com/photo-1549037173-e3b717902c57",
    title: "Vestes formelles repassées",
    alt: "Vestes et costumes repassés - Teinturerie professionnelle"
  }
];

// Videos for gallery (shown BEFORE images)
export const galleryVideos = [
  {
    url: "https://customer-assets.emergentagent.com/job_modern-portfolio-280/artifacts/ina33ds1_13175EI-01-VIDEO%20LAGOON%202013-FRA.mp4",
    title: "Vidéo officielle Lagoon by Electrolux - Nettoyage écologique",
    alt: "Vidéo officielle de présentation de la technologie Lagoon Electrolux - Pressing écologique 0% Perchlo",
    poster: "https://customer-assets.emergentagent.com/job_modern-portfolio-280/artifacts/6gz27als_PHOTO-2026-04-17-19-35-18_2.jpg",
    badge: "🌿 Officielle Lagoon"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_modern-portfolio-280/artifacts/872agh2q_VIDEO-2026-04-17-19-43-03.mp4",
    title: "Visite de notre pressing - Équipements professionnels en action",
    alt: "Vidéo présentation pressing AQUABLUENET - Machines Electrolux et Lagoon en fonctionnement",
    poster: "https://customer-assets.emergentagent.com/job_modern-portfolio-280/artifacts/hgk8peg0_PHOTO-2026-04-17-19-35-48.jpg",
    badge: "📹 Notre pressing"
  }
];

// Kept for backwards compatibility with LagoonSection
export const galleryVideo = galleryVideos[1];

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_modern-portfolio-280/artifacts/36y29qc2_image.png";
export const HERO_IMAGE_URL = "https://customer-assets.emergentagent.com/job_modern-portfolio-280/artifacts/4cu7jfnc_DSCN1144.JPG";
export const LAGOON_VIDEO_URL = "https://customer-assets.emergentagent.com/job_modern-portfolio-280/artifacts/y9daczpu_13175EI-01-VIDEO%20LAGOON%202013-FRA%20%281%29.mp4";
